import _ from 'lodash';
import moment from 'moment'

function calculateInvoiceAmountDue(invoice){
  return invoice.balance.outstanding;
}

const hasPayments = () => (invoice) => {
  return _.size(invoice, 'payments') > 0;
}

const canBePaid = (state, getters) => (index) => {
  let CC_payment_option=null;

  if(getters.unpaidInvoices[index].status.code!="PAID"){
    if (getters.unpaidInvoices[index].paymentOptions != null) { //V1
      CC_payment_option = _.find(getters.unpaidInvoices[index].paymentOptions, paymentOption=>{return paymentOption.code==="CREDIT_CARD"})
    } else {
      // V2
      CC_payment_option = _.find(getters.unpaidInvoices[index].paymentTypes, paymentOption=>{return paymentOption.code==="CREDIT_CARD"})
    }
      
  }
  
  if (state.portausCompanyId != null && state.portausCompanyId != getters.unpaidInvoices[index].portausCompany.id) {
    return false;
  }

  return CC_payment_option!=null;
};

const amountDue = (state) => (invoice) =>{
  return calculateInvoiceAmountDue(invoice);
}

const totalAmountDue = (state) =>{
  let totalAmountDue = 0.00;
  if(state.invoices==null) return totalAmountDue;
  _.forEach(state.invoices, invoice=>{
    totalAmountDue+=calculateInvoiceAmountDue(invoice);
  })
  return totalAmountDue;

}

const isLate = (state) => (invoice) =>{
  if (invoice.inv_number != null) { //V1
    return _.get(invoice, 'status.code') != 'PAID' && moment(new Date).format("YYYY-MM-DD") > moment(invoice.due_date).format("YYYY-MM-DD");
  }
  return _.get(invoice, 'status.code') != 'PAID' && moment(new Date).format("YYYY-MM-DD") > moment(invoice.dueDate).format("YYYY-MM-DD");
}

const nextPaymentDate = (state) =>{
  let nextPaymentDate = null;
  const filteredInvoices = _.filter(state.invoices, i => i.balance.outstanding > 0);
  const orderedInvoices = _.sortBy(filteredInvoices, 'dueDate');
  return _.get(_.head(orderedInvoices), 'dueDate');
}

const isSelected = (state) => (index) => {
  let selectedInvoice = _.find(state.selectedInvoices, s=>{
    s.id==state.invoices[index].id;
  })
  return selectedInvoice!=null;
}

const unpaidInvoices = (state) => {
  let unpaidInvoice = [];
  _.forEach(state.invoices, i=>{
    if(i.status.code!='PAID' && i.status.code!='VOIDED'){
      unpaidInvoice.push(i);
    }
  })
  return unpaidInvoice;
}

const paidInvoices = (state) => {
  let paidInvoice = [];
  _.forEach(state.invoices, i=>{
    if(i.status.code=='PAID'){
      paidInvoice.push(i);
    }
  })
  return paidInvoice;
}

export default {
  canBePaid,
  amountDue,
  totalAmountDue,
  isLate,
  nextPaymentDate,
  isSelected,
  paidInvoices,
  unpaidInvoices,
  hasPayments
};
